export default "__VITE_ASSET__CLAkfqMZ__"